<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
        <div class="card cardcontents">
          <div class="card-header">
            (금일) 진행중인 업무
            <div class="card-more main-header-input">
              <c-plant
                type="search"
                name="plantCd1"
                :isFirstValue="false"
                label=""
                v-model="plantCd1"
                @datachange="getWorkProgress" />
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div v-for="(progress, idx) in workProgressList" 
                :key="idx"
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <q-btn dense @click.prevent="goPage(progress.workName + '-금일업무', '' + progress.url + '.vue',[$comm.getToday(),$comm.getToday()], plantCd1)" :icon="iconItems[idx]" align="left" :color="colorItems[idx]" outline  unelevated :label="progress.workName" class="btn-fixed-width-height">
                  <q-badge color="red" floating transparent>
                    {{ progress.workCount }}
                  </q-badge>
                </q-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
        <div class="card cardcontents">
          <div class="card-header">
            (금일) 작업허가 현황
            <div class="card-more" @click="goPageMap(plantCd2)"><span class="material-icons">add</span><q-tooltip>MAP보기</q-tooltip></div>
            <div class="card-more main-header-input">
              <c-plant
                type="search"
                name="plantCd2"
                :isFirstValue="false"
                label=""
                v-model="plantCd2"
                @datachange="getWorkPermits" />
            </div>
          </div>
          <div class="card-body nopadgrid">
            <c-table
              ref="grid1"
              tableId="grid1"
              :isTitle="false"
              :isDashboard="true"
              :columnSetting="false"
              :usePaging="false"
              :filtering="false"
              :isFullScreen="false"
              :hideBottom="true"
              gridHeight="192px"
              :columns="grid1.columns"
              :data="grid1.data"
              @rowClick="grid1Click"
            >
            </c-table>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" style="padding-right: 0rem !important">
        <div class="card cardcontents">
          <div class="card-header">
            (금년) 교육과정별 이수자/대상자
            <div class="card-more" @click="goPage('연간 교육 추이분석(그래프)','/sop/edu/annualEducationTrendAnalysisGraph.vue', plantCd6)"><span class="material-icons">add</span><q-tooltip>더보기</q-tooltip></div>
            <div class="card-more main-header-input">
              <c-plant
                type="search"
                name="plantCd6"
                :isFirstValue="false"
                label=""
                v-model="plantCd6"
                @datachange="getEduAttendees" />
            </div>
          </div>
          <div class="card-body" style="height:211px">
            <div class="row">
              <div v-for="(attend, idx) in eduAttendees" 
                :key="idx" style="margin-left: 5px; margin-bottom:5px">
                <q-chip square color="white" :clickable="true" text-color="grey-9" @click="eduClick(attend.eduCourseId)">
                  <q-avatar :icon="getEduIcon(attend.educationKindCdLarge)" :color="getEduColor(attend.educationKindCdLarge)" text-color="white">
                    <q-tooltip class="bg-red" anchor="center left" self="center right" :offset="[10, 10]">{{attend.educationKindCdLargeName}}</q-tooltip>
                  </q-avatar>
                  {{attend.educationCourseName}}
                  <div class="attendBoxCnt" v-text="attend.checkCompleteCnt + '명 / ' + attend.checkAllCnt + '명'"></div>
                </q-chip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <div class="card cardcontents">
          <div class="card-header non-label-icon mapheader maincardheader">
            사업장별 대기 자가측정 추이분석
            <div class="card-more" @click="goPage('대기 자가측정 추이분석','/env/air/selfAirMeasureGraph.vue', [airperiod[0],airperiod[1]], plantCd5)"><span class="material-icons">add</span><q-tooltip>더보기</q-tooltip></div>
            <div class="card-more main-header-input">
              <c-plant
                type="none"
                label=""
                name="plantCd5"
                v-model="plantCd5"
                @datachange="getAirchart" />
            </div>
            <div class="card-more main-header-input">
              <c-datepicker
                :range="true"
                defaultStart="-12M"
                defaultEnd="0M"
                type="month"
                name="airperiod"
                v-model="airperiod"
                @datachange="getAirchart"
              />
            </div>
          </div>
          <div class="card-body">
            <apexchart 
              ref="airChart" 
              height="190px" 
              type="line"
              :width="airChart.chartWidth"
              :options="airChart.chartOptions" 
              :series="airChart.series"></apexchart>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" style="padding-right: 0rem !important">
        <div class="card cardcontents">
          <div class="card-body">
            <apexchart 
              ref="yearOcuurChart" 
              height="229px" 
              type="line"
              :options="yearOcuurChart.chartOptions" 
              :series="yearOcuurChart.series"></apexchart>
              <div class="accidentMove card-more" @click="goPage('안전사고 현황','/sop/iim/status/accidentStatus.vue',[],'02,05,07')"><span class="material-icons">add</span><q-tooltip>더보기</q-tooltip></div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
        <div class="card cardcontents">
          <div class="card-body">
            <apexchart 
              ref="imprChart2" 
              height="319px" 
              type="bar"
              :options="imprChart2.chartOptions" 
              :series="imprChart2.series"></apexchart>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
        <div class="card cardcontents">
          <div class="card-body">
            <apexchart 
              ref="imprChart3" 
              height="319px" 
              type="bar"
              :options="imprChart3.chartOptions" 
              :series="imprChart3.series"></apexchart>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <div class="card cardcontents">
          <div class="card-header non-label-icon mapheader maincardheader">
            통합개선 이행율 현황
            <div class="card-more" @click="goPage('개선목록','/sop/ibm/impr.vue', [actionCompleteRequestDates[0], actionCompleteRequestDates[1]], plantCd4)"><span class="material-icons">add</span><q-tooltip>더보기</q-tooltip></div>
            <div class="card-more main-header-input">
              <c-plant
                type="search"
                label=""
                :isFirstValue="false"
                name="plantCd4"
                v-model="plantCd4"
                @datachange="datachange4" />
            </div>
            <div class="card-more main-header-input">
              <c-datepicker
                :range="true"
                defaultStart="-6M"
                defaultEnd="6M"
                type="month"
                name="actionCompleteRequestDates"
                v-model="actionCompleteRequestDates"
                @datachange="getImprStatus"
              />
            </div>
          </div>
          <div class="card-body">
            <apexchart 
              ref="imprChart" 
              height="280px" 
              type="bar"
              :options="imprChart.chartOptions" 
              :series="imprChart.series"></apexchart>
          </div>
        </div>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import selectConfig from '@/js/selectConfig';
export default {
  name: 'main-dashboard-director',
  components: { 
    apexchart: VueApexCharts
  },
  props: {
  },
  data() {
    return {
      popupOptions: {
        isFull: false,
        width: '90%',
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
      plantCd1: null,
      plantCd2: null,
      plantCd3: null,
      plantCd4: null,
      plantCd5: null,
      plantCd6: null,
      airperiod: [],
      eduAttendees: [],
      yearOcuurChart: {
        chartOptions: {
          chart: {
            type: 'line',
            zoom: {
              enabled: false
            },
            toolbar: {
              show: false,
            },
          },
          title: {
            text: '(최근3년) 사고현황',
            align: 'left',
            style: {
              fontSize: "14px",
              color: '#00a1b9'
            }
          },
          dataLabels: {
            enabled: false
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          stroke: {
            width: [3,3,3,3,3,3,3,3],
            curve: 'straight',
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: '건'
            }
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return  + val + " 건"
              }
            }
          }
        },
        series: [],
        chartWidth: '100%',
      },
      imprChart: {
        chartOptions: {
          annotations: { 
            xaxis: [],
          },
          title: {
            // text: '업무별 개선 현황'
          },
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            show: true,
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: undefined
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " 건"
              }
            }
          },
          colors: [
            '#FFC107', '#00BCD4', '#F44336',
          ],
          fill: {
            opacity: 1,
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 10
          },
        },
        series: [
          {
            id: 'actioning',
            name: '조치중',
            data: [],
          },
          {
            id: 'complete',
            name: '개선완료(총합)',
            data: [],
          },
          {
            id: 'overAction',
            name: '지연 건수',
            data: [],
          },
        ],
        chartWidth: '100%',
      },
      imprChart2: {
        chartOptions: {
          annotations: { 
            xaxis: [],
          },
          title: {
            text: '안전 순회점검 개선이행율',
            style: {
              fontSize: "14px",
              color: '#00a1b9'
            }
          },
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            show: true,
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: undefined
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " 건"
              }
            }
          },
          colors: [
            '#FFC107', '#00BCD4', '#F44336',
          ],
          fill: {
            opacity: 1,
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 10
          },
        },
        series: [
          {
            id: 'actioning',
            name: '조치중',
            data: [],
          },
          {
            id: 'complete',
            name: '완료',
            data: [],
          },
          {
            id: 'overAction',
            name: '지연',
            data: [],
          },
        ],
        chartWidth: '100%',
      },
      imprChart3: {
        chartOptions: {
          annotations: { 
            xaxis: [],
          },
          title: {
            text: '환경 순회점검 개선이행율',
            style: {
              fontSize: "14px",
              color: '#00a1b9'
            }
          },
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              endingShape: 'rounded'
            },
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            show: true,
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: undefined
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " 건"
              }
            }
          },
          colors: [
            '#FFC107', '#00BCD4', '#F44336',
          ],
          fill: {
            opacity: 1,
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 10
          },
        },
        series: [
          {
            id: 'actioning',
            name: '조치중',
            data: [],
          },
          {
            id: 'complete',
            name: '완료',
            data: [],
          },
          {
            id: 'overAction',
            name: '지연',
            data: [],
          },
        ],
        chartWidth: '100%',
      },
      airChart: {
        chartOptions: {
          title: {
            text: ''
          },
          annotations: {
            yaxis: [],
          },
         // 그래프 설정
          chart: {
            height: 350,
            type: 'line',
            dropShadow: {
              enabled: true,
              color: '#000',
              top: 18,
              left: 7,
              blur: 10,
              opacity: 0.2
            },
            toolbar: {
              show: false
            },
            zoom: {
              enabled: false
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth',
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: '항목수치'
            }
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          fill: {
            opacity: 1
          },
          markers: {
            size: 1,
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center',
          },
        },
        series: [
          {
            name: "항목수치",
            data: []
          }
        ],
      },
      rate: [],
      safRate: [],
      envRate: [],
      yearUrl: '',
      accident: {
        startYmd: '',
        endYmd: '',
      },
      grid1: {
        listUrl: '',
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'workSummary',
            field: 'workSummary',
            label: '작업개요',
            align: 'left',
            sortable: false,
          },
          {
            name: 'swpStepName',
            field: 'swpStepName',
            label: '진행단계',
            align: 'center',
            sortable: false,
          },
          // {
          //   name: 'permitDate',
          //   field: 'permitDate',
          //   label: '허가일',
          //   align: 'center',
          //   sortable: false,
          // },
          {
            name: 'permitTypeName',
            field: 'permitTypeName',
            label: '허가서구분',
            align: 'center',
            sortable: false,
          },
        ],
        data: [],
      },
      grid2: {
        listUrl: '',
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'ibmTaskTypeName',
            field: 'ibmTaskTypeName',
            label: '업무',
            align: 'center',
            sortable: false,
          },
          {
            name: 'ibmTitle',
            field: 'ibmTitle',
            label: '제목',
            align: 'left',
            style: 'width:250px',
            sortable: false,
          },
          {
            name: 'ibmStepName',
            field: 'ibmStepName',
            label: '진행단계',
            align: 'center',
            sortable: false,
          },
          {
            name: 'actionCompleteRequestDate',
            field: 'actionCompleteRequestDate',
            label: '조치완료 요청일',
            align: 'center',
            sortable: false,
          },
        ],
        data: [],
      },
      rateUrl: '',
      airlistUrl: '',
      patrolUrl: '',
      eduAttendUrl: '',
      workPermitUrl: '',
      imprProgressUrl: '',
      workProgressUrl: '',
      actionCompleteRequestDates: [],
      workProgressList: [],
      showTooltopCnt: 0,
      showTooltop: [false,false,false,false,false,false,false,false],
      iconItems: ['school','settings_applications','build','build_circle','restore','manage_accounts','report','report_problem'],
      colorItems: ['primary','secondary','amber-9','deep-orange','secondary','brown-5','purple','green-7',],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.showTooltopCnt = 0
      this.yearUrl = selectConfig.sop.iim.accident.status.year.url;
      this.rateUrl = selectConfig.main.imprChart.url;
      this.patrolUrl = selectConfig.main.patrolChart.url;
      this.workPermitUrl = selectConfig.main.workPermitStatus.url;
      this.imprProgressUrl = selectConfig.main.imprProgress.url;
      this.workProgressUrl = selectConfig.main.workProgress.url;
      this.eduAttendUrl = selectConfig.main.eduAttendees.url;
      this.airlistUrl = selectConfig.env.air.self.measure.graph.url;

      // 년도 설정
      let years = [];
      for (let i = 0; i < 3; i++) {
        years.splice(0, 0, this.$comm.getPrevYear(i));
      }
      this.yearOcuurChart.chartOptions.xaxis.categories = years;

      this.accident.startYmd = years[0];
      this.accident.endYmd = years[4];

      this.getYearList();
      this.getImprStatus(null);
      this.getSafPatrols();
      this.getEnvPatrols();
      this.getWorkPermits();
      // this.getImprProgress();
      this.getWorkProgress();
      this.getAirchart();
      this.getEduAttendees();

      // this.intervalTooltip1();
    },
    getWorkProgress() {
      this.$http.url = this.workProgressUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.plantCd1
      }
      this.$http.request((_result) => {
        this.workProgressList = _result.data
      },);
    },
    getWorkPermits() {
      this.$http.url = this.workPermitUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.plantCd2,
      };
      this.$http.request((_result) => {
        this.grid1.data = _result.data
      },);
    },
    getImprProgress() {
      this.$http.url = this.imprProgressUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.plantCd3,
      };
      this.$http.request((_result) => {
        this.grid2.data = _result.data
      },);
    },
    getEduAttendees() {
      this.$http.url = this.eduAttendUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.plantCd6,
      };
      this.$http.request((_result) => {
        this.eduAttendees = _result.data
      },);
    },
    intervalTooltip1() {
      this.isToolTip1 = setInterval(() => {
        if (this.showTooltopCnt == 8) {
          this.showTooltopCnt = 0;
        }
        for(let c = 0; c < 8; c++) {
          this.showTooltop[c] = false;
        }
        this.showTooltop[this.showTooltopCnt] = true;
        this.showTooltopCnt++;
      }, 2000);
    },
    getSafPatrols() {
      this.$http.url = this.patrolUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        ibmTaskTypeCd: 'ITT0000065',
      },
      this.safRate = [];
      this.$http.request((_result) => {
        let taskIdx = 0;
        this.$_.forEach(_result.data, task => {
          this.$_.forEachRight(this.imprChart2.series, item => {
            if (!this.safRate[taskIdx] && task[item.id] > 0) {
              this.safRate[taskIdx] = task.requestTotal > 0 ?
                String(this.$_.round((task.complete / task.requestTotal) * 100)) + '%' : '0%';
            }
          })
          taskIdx++;
        })
        this.$_.forEach(this.imprChart2.series, item => {
          item.data = this.$_.map(_result.data, item.id)
        })
        let xaxis = this.$_.map(_result.data, 'plantName');
        let annotations = [];
        this.safRate.forEach((r, idx) => {
          // xaxis[idx] += (r ? '(' + r + ')' : '');
          annotations[idx] = {
            x: xaxis[idx],
            strokeDashArray: 0,
            borderColor: '#EEEEEE',
            borderWidth: 0,
            label: {
              borderColor: '#775DD0',
              orientation: 'horizontal',
              style: {
                color: '#fff',
                fontSize: '12px',
                background: '#775DD0',
              },
              text: r ? r : '',
              // text: r ? '이행률 : ' + r : '',
            }
          }
        })
        xaxis.forEach((x, idx) => {
          if (!annotations[idx]) {
            annotations[idx] = {
              x: x,
              strokeDashArray: 0,
              borderColor: '#EEEEEE',
              borderWidth: 0,
              // borderColor: '#775DD0',
              label: {
                borderColor: '#775DD0',
                orientation: 'horizontal',
                style: {
                  color: '#fff',
                  fontSize: '12px',
                  background: '#775DD0',
                },
                text: '',
              }
            }
          }
        })
        this.imprChart2.chartOptions.xaxis.categories = xaxis;
        this.imprChart2.chartOptions.annotations.xaxis = annotations;
        
        this.imprChart2.chartWidth = '100%';
        this.$refs['imprChart2'].refresh();
      },);
    },
    getAirchart() {
      this.$http.url = this.airlistUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.plantCd5,
        airInspectTypeCd: 'AITC000001',
        startYmd: this.airperiod[0],
        endYmd: this.airperiod[1],
      };
      this.$http.request((_result) => {
        this.airChart.series = [];
        let xaxis = [];

        // series.data length 구하기
        let len = _result.data.filter((_item, _idx) => {
          return _result.data.findIndex((__item) => {
            // console.log(__idx)
            return _item.envAirSelfMeasureMstId === __item.envAirSelfMeasureMstId
          }) === _idx;
        }).length

        this.$_.forEach(_result.data, _item => {
          // console.log(_item.envAirSelfMeasureMstName)
          let idx = xaxis.indexOf(_item.envAirSelfMeasureMstName) 
          if (idx === -1) {
            xaxis.push(_item.envAirSelfMeasureMstName)
          }
          if (_item.envAirMstInspectItemIds) {
            if (this.$_.findIndex(this.airChart.series, { envAirMstInspectItemId: _item.envAirMstInspectItemIds }) === -1) {
              this.airChart.series.push({
                envAirMstInspectItemId: _item.envAirMstInspectItemIds,
                name: _item.envAirMstInspectItemNames,
                data: Array.from({length : len}, () => 0),
              })
            }

            this.airChart.series[this.$_.findIndex(this.airChart.series, {envAirMstInspectItemId: _item.envAirMstInspectItemIds })]
            .data[idx] = _item.measures
            
          }
        })
        this.airChart.chartOptions.xaxis.categories = xaxis
        this.$refs['airChart'].refresh();
      });
    },
    getEnvPatrols() {
      this.$http.url = this.patrolUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        ibmTaskTypeCd: 'ITT0000135',
      },
      this.envRate = [];
      this.$http.request((_result) => {
        let taskIdx = 0;
        this.$_.forEach(_result.data, task => {
          this.$_.forEachRight(this.imprChart3.series, item => {
            if (!this.envRate[taskIdx] && task[item.id] > 0) {
              this.envRate[taskIdx] = task.requestTotal > 0 ?
                String(this.$_.round((task.complete / task.requestTotal) * 100)) + '%' : '0%';
            }
          })
          taskIdx++;
        })
        this.$_.forEach(this.imprChart3.series, item => {
          item.data = this.$_.map(_result.data, item.id)
        })
        let xaxis = this.$_.map(_result.data, 'plantName');
        let annotations = [];
        this.envRate.forEach((r, idx) => {
          // xaxis[idx] += (r ? '(' + r + ')' : '');
          annotations[idx] = {
            x: xaxis[idx],
            strokeDashArray: 0,
            borderColor: '#EEEEEE',
            borderWidth: 0,
            label: {
              borderColor: '#775DD0',
              orientation: 'horizontal',
              style: {
                color: '#fff',
                fontSize: '12px',
                background: '#775DD0',
              },
              text: r ? r : '',
              // text: r ? '이행률 : ' + r : '',
            }
          }
        })
        xaxis.forEach((x, idx) => {
          if (!annotations[idx]) {
            annotations[idx] = {
              x: x,
              strokeDashArray: 0,
              borderColor: '#EEEEEE',
              borderWidth: 0,
              // borderColor: '#775DD0',
              label: {
                borderColor: '#775DD0',
                orientation: 'horizontal',
                style: {
                  color: '#fff',
                  fontSize: '12px',
                  background: '#775DD0',
                },
                text: '',
              }
            }
          }
        })
        this.imprChart3.chartOptions.xaxis.categories = xaxis;
        this.imprChart3.chartOptions.annotations.xaxis = annotations;
        
        this.imprChart3.chartWidth = '100%';
        this.$refs['imprChart3'].refresh();
      },);
    },
    getYearList() {
      this.$http.url = this.yearUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.yearOcuurChart.series = [];

        this.$_.forEach(_result.data, _item => {
        // 년도에 따른 idx를 구하여 series.data의 위치 통일
          let idx = this.yearOcuurChart.chartOptions.xaxis.categories.indexOf(_item.occurYear)
          if (this.$_.findIndex(this.yearOcuurChart.series, { plantCd: _item.plantCd}) === -1) {
            this.yearOcuurChart.series.push({
              plantCd: _item.plantCd,
              name: _item.plantName,
              data: [0, 0, 0]
            })
          }
          this.yearOcuurChart.series[this.$_.findIndex(this.yearOcuurChart.series, 
          { plantCd: _item.plantCd })].data[idx] = _item.yearCount
        })
        this.setChart();
      },);
    },
    setChart() {
      setTimeout(() => {
        this.yearOcuurChart.chartWidth = '90%';
      }, 200);
      this.$refs['yearOcuurChart'].refresh();
    },
    datachange4(props) {
      if (props.value === '전체') {
        this.getImprStatus(null);
      } else {
        this.getImprStatus(props.value);
      }
    },
    getImprStatus(_plantCd) {
      this.$http.url = this.rateUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: _plantCd,
        actionCompleteRequestDates: this.actionCompleteRequestDates,
        directorFlag: 'Y',
      }
      this.rate = [];
      this.$http.request((_result) => {
        let taskIdx = 0;
        this.$_.forEach(_result.data, task => {
          this.$_.forEachRight(this.imprChart.series, item => {
            if (!this.rate[taskIdx] && task[item.id] > 0) {
              this.rate[taskIdx] = task.requestTotal > 0 ?
                String(this.$_.round((task.complete / task.requestTotal) * 100)) + '%' : '0%';
            }
          })
          taskIdx++;
        })
        this.$_.forEach(this.imprChart.series, item => {
          item.data = this.$_.map(_result.data, item.id)
        })
        let xaxis = this.$_.map(_result.data, 'ibmTaskTypeName');
        let annotations = [];
        this.rate.forEach((r, idx) => {
          xaxis[idx] += (r ? '(' + r + ')' : '');
          annotations[idx] = {
            x: xaxis[idx],
            strokeDashArray: 0,
            borderColor: '#EEEEEE',
            borderWidth: 0,
            label: {
              borderColor: '#775DD0',
              orientation: 'horizontal',
              style: {
                color: '#fff',
                fontSize: '12px',
                background: '#775DD0',
              },
              text: r ? r : '',
              // text: r ? '이행률 : ' + r : '',
            }
          }
        })
        xaxis.forEach((x, idx) => {
          if (!annotations[idx]) {
            annotations[idx] = {
              x: x,
              strokeDashArray: 0,
              borderColor: '#EEEEEE',
              borderWidth: 0,
              // borderColor: '#775DD0',
              label: {
                borderColor: '#775DD0',
                orientation: 'horizontal',
                style: {
                  color: '#fff',
                  fontSize: '12px',
                  background: '#775DD0',
                },
                text: '',
              }
            }
          }
        })
        this.imprChart.chartOptions.xaxis.categories = xaxis;
        this.imprChart.chartOptions.annotations.xaxis = annotations;
        
        this.imprChart.chartWidth = '100%';
        this.$refs['imprChart'].refresh();
      },);
    },
    getEduIcon(_code) {
      let returntext = '';
      switch(_code) {
        case 'EKFC000001': // 안전보건
          returntext = 'engineering';
          break;
        case 'EKFC000002': // 환경
          returntext = 'public';
          break;
        default: // 그외
          returntext = 'school';
          break;
      }
      return returntext;
    },
    getEduColor(_code) {
      let returntext = '';
      switch(_code) {
        case 'EKFC000001': // 안전보건
          returntext = 'blue-6';
          break;
        case 'EKFC000002': // 환경
          returntext = 'orange-6';
          break;
        default: // 그외
          returntext = 'grey-7';
          break;
      }
      return returntext;
    },
    goPage(_title, _page, _period, _plantCd) {
      this.popupOptions.title = _title;
      this.popupOptions.width = '90%';
      this.popupOptions.param = {
        mainPeriod: _period === undefined ? [] : _period,
        mainPlantCd: _plantCd === undefined ? '' : _plantCd,
      };
      this.popupOptions.target = () => import(`@/pages${_page}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    grid1Click(_row) {
      this.popupOptions.title = '작업허가서';
      this.popupOptions.width = '90%';
      this.popupOptions.isFull = true;
      this.popupOptions.param = {
        sopWorkPermitId: _row ? _row.sopWorkPermitId : '',
        permitTypeCd: _row ? _row.permitTypeCd : '',
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/swp/safeWorkPermitDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    eduClick(_eduCourseId) {
      this.popupOptions.title = "교육 과정 상세"; // 교육 과정 상세
      this.popupOptions.width = '90%';
      this.popupOptions.isFull = true;
      this.popupOptions.param = {
        eduCourseId: _eduCourseId ? _eduCourseId : '',
      };
      this.popupOptions.target = () => import(`${"@/pages/sop/edu/cc/educationCurriculumDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    goPageMap(_plantCd) {
      this.popupOptions.width = '60%';
      this.popupOptions.title = "작업허가 MAP"; // 교육 과정 상세
      this.popupOptions.param = {
        mainPlantCd: _plantCd ? _plantCd : null,
      };
      this.popupOptions.target = () => import(`${'./indexMap.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    }
  }
};
</script>
<style lang="sass">
  .cardcontents
    margin-top: 6px
    margin-bottom: 6px
    margin-right: 6px
    .card-body
      padding: 10px !important
    .card-header:before
      font-family: "Material Icons"
      content: "\e876"
    .card-header
      height: 40px
      color: #00a1b9
      background: #f8f8f8
      display: inline-block
      padding-top: 8px
      .card-more
        float: right !important
        cursor: pointer
        color: #4DB6AC
      .card-more:hover
        color: #00a1b9
.card-more
  cursor: pointer
  color: #d2d2d2
.card-more:hover
  color: #00a1b9
.main-header-input
  margin-top: -5px
  padding-right: 5px
  .customDate
    padding-bottom: 0 !important
    .q-field__inner
      padding: 0 !important
.main-header-input2
  margin-top: -5px
  padding-right: 5px
  .customDate
    padding-bottom: 0 !important
    .q-field__inner
      padding: 0 !important
.cardcontents .card-body.nopadgrid
  padding-top: 0px !important
.btn-fixed-width-height
  width: 95%
  margin: 3px !important
  // pointer-events: none
.attendBoxCnt
  background: #f44336
  margin-left: 10px
  color: #fff
  padding: 2px 8px 2px 8px
  border-radius: 7px
.accidentMove
  position: absolute
  top: 10px
  right: 20px
  cursor: pointer
</style>